import React, { useEffect, useState } from "react";
import { AppLayout, Backdrop, Box, CustomButton, CustomConfirmDialog, CustomDataGrid, DatePicker, Grid2, GridColDef, Toaster, Typography, useApi } from "../utils/globalImports";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DateCalendar } from "@mui/x-date-pickers";
import { ConfirmDialog } from "@toolpad/core";
import { isAdmin, isCommercial, isSMT } from "../interfaces/userRoles";
import { Warning, WarningAmber } from "@mui/icons-material";

interface HistoryData {
  id: number,
  configId: number,
  year: string,
  month: string,
  oldStartDay: string | null,
  newStartDay: string | null,
  actionType: string,
  changeById: number,
  changedByName: string,
  changedOn: string | null
}
interface ConfigDate {
  id: number,
  year: number,
  month: number,
  startDate: number,
  endDate: number,
}
interface ActiveMonthDetails{
  year:number,
  month:number,
  currentLockDate:Date,
  minAllowedDate:Date,
  maxAllowedDate:Date
}
const Settings: React.FC = () => {
  const columns = [
    {
      field: "month",
      headerName: "Month",
      flex: 1,
      sortable: false,
    },
    {
      field: "oldStartDay",
      headerName: "Old Date",
      flex: 1,
      sortable: false,
    },
    {
      field: "newStartDay",
      headerName: "New Date",
      sortable: false,
      flex: 1,
    },
    {
      field: "changedByName",
      headerName: "Changed By",
      flex: 1,
      valueFormatter: (params: any) => params.value ?? "",
    },
    {
      field: "changedOn",
      headerName: "Changed On",
      flex: 1,
    }
  ];
  const { execute,loading } = useApi();

  const userId = localStorage.getItem('userId');
  const today = dayjs()
  const [toast, setToast] = useState({ open: false, message: "", type: "error" });
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const calenderStartDate = dayjs().endOf("month")
  const calenderEndDate = dayjs()
    .add(1, "month")
    .endOf("month")
    .subtract(1, "day");
  const [historyData, setHistoryData] = useState<HistoryData[]>([]);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [activeMonthDetails,setActiveMonthDetails]=useState<ActiveMonthDetails|null>(null);
  const [currentMonthLockDate, setCurrentMonthLockDate] = useState<Date | null>(null)
  const [nextMonthLockDate, setNextMonthLockDate] = useState<Date | null>(null)

  const handleSetNewDate = () => {
    if (!selectedDate) {
      setToast({ open: true, message: "Please Select the Date first", type: "error" })
    }
    else {
      setDialogOpen(true)
    }
  }
  useEffect(() => {
    fetchHistory()
   fetchActiveMonthDetails()     }, [])
  const handleConfirm = () => {
    setLockDate();

  };
  const setLockDate = async () => {
  if (!selectedDate || !activeMonthDetails) return;

    const payload = {
    year: activeMonthDetails.year,
    month: activeMonthDetails.month,
      selectedDate: selectedDate.format("YYYY-MM-DD"),
      adminId: userId,
    };
    try {
    const response = await execute(
      "post",
      "BaselineConfig/setdate",
      payload
    );

      if (!response || response.error) {
      setToast({
        open: true,
        message: "Failed to Set New date",
        type: "error",
      });
        throw new Error("API failed");
      }

    fetchHistory();

    setToast({
      open: true,
      message: "Date Updated Successfully",
      type: "success",
    });

    setDialogOpen(false);
    setSelectedDate(null);
    } catch (error) {
    setToast({
      open: true,
      message: "Error in updating the Date",
      type: "error",
    });
    }
  };
const fetchActiveMonthDetails = async () => {


    try {
      const {data} = await execute<ActiveMonthDetails>(
        "get",
        `BaselineConfig/GetActiveMonthDetails`
      );
      setActiveMonthDetails(data);
    } catch (error) {
      setToast({ open: true, message: "Failed to fetch config dates", type: "error" })
    }
  };
  const fetchHistory = async () => {
    const response = await execute<HistoryData[]>('get', 'BaselineConfig/getconfighistory');
    const formattedData = response?.data?.map((item) => ({
      ...item,
      month: dayjs().month(Number(item.month) - 1).format("MMMM"),
      oldStartDay: item.oldStartDay ? dayjs(item.oldStartDay).format("DD/MM/YYYY") : null,
      newStartDay: item.newStartDay ? dayjs(item.newStartDay).format("DD/MM/YYYY") : null,
      changedOn: item.changedOn ? dayjs(item.changedOn).format("DD/MM/YYYY") : null,
      changedByName: item.changedByName == "null" ? "Default" : item.changedByName
    }));
    setHistoryData(formattedData || []);
    fetchActiveMonthDetails();
  }
  return (  
    <AppLayout>
      <Box sx={{display: 'flex', flexDirection: 'column', height: '100%',overflow: 'hidden'}}>
       
        <Box
          sx={{
            border: "1px solid #e0e0e0",
            boxShadow: "0px 2px 8px rgba(0,0,0,0.12)",
            borderRadius: "12px",
            padding: "24px",
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 600, color: '#1e66ab' }}>
            Settings
          </Typography>
          <Box sx={{
            display: 'flex',
            width: '100%',
            gap: '20px',
            height: 'auto',
            color: 'orange',
            border: "1px solid orange",
            borderRadius:"8px",
            p:1,
            backgroundColor:"rgba(247, 180, 104, 0.12)",
            mt:1
          }}>
            <Warning sx={{px:0}}/>
              {`The Current Lock Date for ${
    activeMonthDetails?.month
      ? dayjs().month(activeMonthDetails.month - 1).format('MMMM')
      : ''
  } is ${
    activeMonthDetails?.currentLockDate
      ? dayjs(activeMonthDetails.currentLockDate).format('DD/MM/YYYY')
      : ''
  }`}
          </Box>
          {/* <Box sx={{ display: 'flex', width: '50%', gap: '20px', height: 'auto', color: '#1e66ab' }}>{`The Current Lock Date for ${dayjs().add(1,"month").format("MMMM")} is ${nextMonthLockDate ? dayjs(nextMonthLockDate).format("DD") : ""}`}</Box> */}
          <Box sx={{ marginTop: '20px', display: 'flex', width: '50%', gap: '20px', height: 'auto', flexDirection: "column" }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#1e66ab',mb:-2 }}>
              Set Lock Date
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "20px"
              }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
            sx={{ width: '400px' }}
                  value={selectedDate}
                  minDate={
                activeMonthDetails?.minAllowedDate
                  ? (
                      dayjs().isBefore(dayjs(activeMonthDetails.minAllowedDate), "day")
                        ? dayjs(activeMonthDetails.minAllowedDate)
                        : dayjs()
                    )
                  : dayjs()
              }
            maxDate={
              activeMonthDetails?.maxAllowedDate
                ? dayjs(activeMonthDetails.maxAllowedDate)
                : undefined
                  }
                  format="DD/MM/YYYY"
                  onChange={(newValue) => setSelectedDate(newValue)}
                />
              </LocalizationProvider>
              <Grid2 sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', gap: '20px' }}>
                <CustomButton onClick={handleSetNewDate}>Set Date</CustomButton>
                <CustomButton backgroundColor={' #1e66ab'} hoverColor={'rgba(150, 193, 33, 0.75)'} onClick={() => { setSelectedDate(null) }}>Cancel</CustomButton>
              </Grid2>
            </Box>
          </Box>
        </Box>
        <CustomConfirmDialog
          open={dialogOpen}
          title="Update Lock Date"
          message={`Are you sure you want to update the Lock date from ${dayjs(activeMonthDetails?.currentLockDate)?.format("DD/MM/YYYY")} to ${selectedDate?.format("DD/MM/YYYY")}?`}
          onConfirm={() => { handleConfirm() }}
          onClose={() => { setDialogOpen(false); setSelectedDate(null) }}
          onCancel={() => { setDialogOpen(false); setSelectedDate(null) }}
        />
        <Toaster open={toast.open} message={toast.message} type={toast.type as "success" | "error"} onClose={() => setToast({ ...toast, open: false })} />
        <Box sx={{
          mt: 3,
          border: "1px solid #e0e0e0",
          boxShadow: "0px 2px 8px rgba(0,0,0,0.12)",
          borderRadius: "12px",
          padding: "24px",
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}>
          <Typography  variant="h6" sx={{  color: "#1e66ab", fontWeight: 600, ml: 0 ,mb:0.5}}>
            Lock History:
          </Typography>
           <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                      <CustomDataGrid rows={historyData || []} columns={columns} setRowHeigt={true} setHeight="500px" />
                      <Backdrop open={loading}/>
          </Box>
        </Box>
      </Box>
    </AppLayout>

  );
};


export default Settings;